import { EuiFlexGroup, EuiFlexItem, EuiPanel, EuiSpacer, EuiLoadingSpinner } from "@elastic/eui"
import { Listado } from "./lista"
import {MenuLista} from "./menu"
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import "./styles.css"

export const Screen = forwardRef((props:any, ref:any) =>{

    const {data, dataUser, menu} = props;

    let [selected,setSelected] = useState<any>([])
    const [checkAll, setCheckAll] = useState<any>(false)
    const [dataList, setDataList] = useState<any>([]);

    useEffect(()=> setSelected((oldArray:any) => dataUser && [...oldArray,...dataUser]),[dataUser])
    
    useEffect(()=>{
        if(checkAll!==undefined){
            checkAll ?  setSelected((oldArray:any) => [...data.map((d:any)=> d)]) : setSelected([])
        }
    },[checkAll])

    const getCentro = (id?:string)=> (id === null || id ==='') ? '' : `/${id}`

    const getLabel = (dataCentro:any)=> `${dataCentro.idCentro}-${dataCentro.descripcion}`
    const getJerarchy = (dataCentro:any)=> {
        const CPadre = dataCentro.idCentroPadre;

        const CDE = getCentro(dataCentro.idCentroDE) 
        const CD2 = getCentro(dataCentro.idCentroD2) 
        const CDN = getCentro(dataCentro.idCentroDN) 
        const CDG = getCentro(dataCentro.idCentroDG) 
        const CSG = getCentro(dataCentro.idCentroSG) 

        return `${CPadre}${CDE}${CD2}${CDN}${CDG}${CSG}` 
    }

    useEffect(()=>{
        if(data &&  data.length>0){
            let newData = data.map((d:any)=> {
                return {idCentro:d.idCentro, label: `${getLabel(d)} (${getJerarchy(d)})`, tipoCentro: d.tipoCentro}
            })

            setDataList((oldArray:any) => [...newData])
        }
    },[data])

    useEffect(()=>{
        if(dataUser &&  dataUser.length>0){
            let newData = dataUser.map((d:any)=> {
                return {idCentro:d.idCentro, label: `${getLabel(d)}`, tipoCentro: d.tipoCentro}
            })

            setSelected((oldArray:any) => [...newData])
        }
    },[dataUser])

    const onClickItem = (item:any) =>{
        const newItem = {...item}
        newItem.label = newItem.label.split('(')[0]
        setSelected((oldArray:any) => [...oldArray,newItem])
    }

    const onRemoveItem = (item:any) =>{
        setSelected((oldArray:any) => {
            const pos = selected.findIndex((f:any)=> f.idCentro === item.idCentro)
            oldArray.splice(pos,1)
            return [...oldArray]
        })
    }

    const getItemsNumber = useMemo(()=> data.length,[data])
    const getItemsSelect = useMemo(()=> selected.length,[selected])

    const getMenu:any = useMemo(() => 
    menu ? (<EuiPanel><MenuLista onChange={setCheckAll} checkAll={checkAll} itemsNumber={getItemsNumber} itemsSelection={getItemsSelect}/></EuiPanel>) 
    : null,[checkAll,data,selected])

    useImperativeHandle(
        ref,
        () => ({
            onSave() {
                const ids = selected.map((s:any) => s.idCentro);
                return ids.join();
            }
        })
    )

    const getTituloCentros = {titulo:"CENTROS", color: "default"}
    const getTituloCentrosUsuario = {titulo:"CENTROS USUARIO", color: "secondary"}
    
    return (
        <>
        {getMenu}
        <EuiSpacer size="m"/>
        <EuiFlexGroup style={{height:'90%'}}> 
        {dataList && dataList.length > 0 ?
        <>
            <EuiFlexItem style={{width: '45%'}}>
                <Listado titulo={getTituloCentros} data={dataList} onClickItem={onClickItem} selected={selected} search/>
            </EuiFlexItem>
            <EuiFlexItem style={{width: '45%'}}>
                <Listado titulo={getTituloCentrosUsuario} data={selected} actions={true} onRemoveItem={onRemoveItem}/>
            </EuiFlexItem>
        </>

        :    <EuiFlexItem style={{height:'200px', width:'100%', justifyContent:'center', alignItems: 'center'}}>
                <EuiLoadingSpinner size="xl" />
            </EuiFlexItem>}
        </EuiFlexGroup>
        </>
    )
})